export default __webpack_public_path__ + "static/media/content01.cb34cd08.png";